var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDividerNonprofits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 116,
    viewBox: "0 0 1280 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430.446 32.7732C284.141 -10.2268 168.148 60.4997 92.6807 118H1280.25V6.49971C1215.43 -2.66696 1081.85 -3.4467 972.587 18.5533C836.005 46.0533 576.751 75.7732 430.446 32.7732Z",
    fill: "#C996CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M506.5 48.5001C364 107.5 144 -20.9999 0 5.00007V118H1280.5V32.5001C1195.5 77.1668 1012.3 147.4 959.5 71.0001C893.5 -24.4999 649 -10.4999 506.5 48.5001Z",
    fill: "#3D2C8D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerNonprofits);
export default __webpack_public_path__ + "static/media/divider_nonprofits.e77c857b4ea0e93ee63e766cdc64068a.svg";
export { ForwardRef as ReactComponent };